import React from 'react';
import { Table, Input } from 'semantic-ui-react';
import TagsBlock from '../../TagsBlock';
import { FitnessFuncContent, MenuTagName, Label, MenuTagNameDisabled } from '../userPageStyles';
import { breakfastTags, dinnerTags } from '../../youslim2.0_Constants';

const MenuStructureBlock = React.memo(
  ({
    isMorningSnack,
    setIsMorningSnack,
    isAfternoonSnack,
    setIsAfternoonSnack,
    isEveningSnack,
    setIsEveningSnack,
    choosedBreakfastTags,
    setChoosedBreakfastTags,
    choosedLunchTags,
    setChoosedLunchTags,
    choosedDinnerTags,
    setChoosedDinnerTags,
    match,
  }) => {
    return (
      <FitnessFuncContent>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Завтрак</Table.HeaderCell>
              <Table.HeaderCell>
                <Label>
                  <Input
                    type="checkbox"
                    style={{ width: 'auto' }}
                    value={isMorningSnack}
                    checked={isMorningSnack}
                    onChange={() => setIsMorningSnack(!isMorningSnack)}
                  />
                  {isMorningSnack ? (
                    <MenuTagName>Утренний перекус</MenuTagName>
                  ) : (
                    <MenuTagNameDisabled>Утренний перекус</MenuTagNameDisabled>
                  )}
                </Label>
              </Table.HeaderCell>
              <Table.HeaderCell>Обед</Table.HeaderCell>
              <Table.HeaderCell>
                <Label>
                  <Input
                    type="checkbox"
                    style={{ width: 'auto' }}
                    value={isAfternoonSnack}
                    checked={isAfternoonSnack}
                    onChange={() => setIsAfternoonSnack(!isAfternoonSnack)}
                  />
                  {isAfternoonSnack ? (
                    <MenuTagName>Дневной перекус</MenuTagName>
                  ) : (
                    <MenuTagNameDisabled>Дневной перекус</MenuTagNameDisabled>
                  )}
                </Label>
              </Table.HeaderCell>
              <Table.HeaderCell>Ужин</Table.HeaderCell>
              <Table.HeaderCell>
                <Label>
                  <Input
                    type="checkbox"
                    style={{ width: 'auto' }}
                    value={isEveningSnack}
                    checked={isEveningSnack}
                    onChange={() => setIsEveningSnack(!isEveningSnack)}
                  />
                  {isEveningSnack ? (
                    <MenuTagName>Вечерний перекус</MenuTagName>
                  ) : (
                    <MenuTagNameDisabled>Вечерний перекус</MenuTagNameDisabled>
                  )}
                </Label>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <TagsBlock
                  allTags={breakfastTags}
                  choosedTags={choosedBreakfastTags}
                  setChoosedTags={setChoosedBreakfastTags}
                  flexBasis="20%"
                  isBorder={false}
                />
              </Table.Cell>
              <Table.Cell />
              <Table.Cell>
                <TagsBlock
                  allTags={dinnerTags}
                  choosedTags={choosedLunchTags}
                  setChoosedTags={setChoosedLunchTags}
                  flexBasis="20%"
                  isBorder={false}
                />
              </Table.Cell>
              <Table.Cell />
              <Table.Cell>
                <TagsBlock
                  allTags={dinnerTags}
                  choosedTags={choosedDinnerTags}
                  setChoosedTags={setChoosedDinnerTags}
                  flexBasis="20%"
                  isBorder={false}
                />
              </Table.Cell>
              <Table.Cell />
            </Table.Row>
          </Table.Body>
        </Table>
      </FitnessFuncContent>
    );
  },
);

export default MenuStructureBlock;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/TestPage/MenuStructureBlock/index.js